<template>
  <div class="p-8 bg-white">
    <h1>Edit widget configuration</h1>

    <Form
      v-if="widget"
      :form-id="formId"
      :initial-values="widget"
      @submit="save"
    >
      <WidgetFields />

      <div class="my-8 flex gap-2">
        <VPButton
          type="button"
          variant="outline"
          label="Delete"
          class="py-2 px-4 text-vp-error"
          @click="onDelete"
        />
        <VPButton
          type="submit"
          label="Save"
          class="py-2 px-4"
        />
      </div>
    </Form>
  </div>
</template>

<script setup lang="ts">
import { Form, useFormsStoreComposable } from 'vuniform';
import WidgetFields from '@/components/widget/WidgetFields.vue';
import VPButton from '@/components/form/VPButton.vue';
import { useRootStore } from '@/stores/root';
import { useWidgetsStore } from '@/stores/widgets';
import { computed, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import type { WidgetAttributes } from '@/generated/graphql';
import { useToast } from 'vue-toastification';

const { formId, formGetValues } = useFormsStoreComposable('widget-config-form-edit');

const toast = useToast();
const route = useRoute();
const router = useRouter();
const rootStore = useRootStore();
const widgetsStore = useWidgetsStore();
onMounted(async () => {
  await widgetsStore.fetchWidgets(rootStore.currentAccountId);
});

const widget = computed(() => widgetsStore.widgets.find(({ id }) => id == +route.params.widgetId));

const save = async () => {
  const values = formGetValues() as WidgetAttributes;

  await widgetsStore.saveWidget(rootStore.currentAccountId, values);
  toast.success('Widget configuration has been updated!');
  await router.push({ name: 'WidgetConfigIndex' });
};

const onDelete = async () => {
  const confirmed = confirm(`Are you sure you want to delete the widget ${widget.value!.description}`);
  if (!confirmed) {
    return;
  }

  await widgetsStore.deleteWidget(rootStore.currentAccountId, widget.value!.id!);
  toast.success(`Widget ${widget.value!.description} has been deleted!`);
  await router.push({ name: 'WidgetConfigIndex' });
};
</script>
